import { Switch as BlueprintSwitch } from '@blueprintjs/core';
import _classNames from 'clsx';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

/**
 * The switch is an alternate appearance for a checkbox that simulates on/off instead of checked/unchecked.
 * Utilizes the `Switch` component from blueprintjs.
 * For a complete reference of the blueprintjs component, visit https://blueprintjs.com/docs/#core/components/switch
 */
function Switch({ checked, classes, defaultChecked, onChange, innerRef }) {
  return (
    <BlueprintSwitch
      checked={checked}
      className={_classNames('Switch', classes, {
        'Switch--checked': checked,
      })}
      defaultChecked={defaultChecked}
      inline
      inputRef={innerRef}
      large
      onChange={onChange}
    />
  );
}

Switch.propTypes = {
  /**
   * Set to true to show the switch is currently on
   */
  checked: PropTypes.bool,
  /**
   * Classes to apply to the `label` element wrapping the Switch
   */
  classes: PropTypes.string,
  /**
   * This function is called when the user clicks to toggle the Switch
   */
  onChange: PropTypes.func,
  /**
   * Inner Ref
   */
  innerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  defaultChecked: PropTypes.bool,
};

Switch.defaultProps = {
  checked: undefined,
  classes: undefined,
  onChange: undefined,
  innerRef: undefined,
  defaultChecked: undefined,
};

export default forwardRef((props, ref) => <Switch innerRef={ref} {...props} />);
